import type { IntakeApi } from '../api/client';
import { consoleSink, fanOut, type AnalyticsSink } from './analytics';
import { createEnquiryEventsSink } from './enquiryEvents';
import { createGtagSink, createMetaPixelSink, parseConversions } from './thirdParty';

type Env = Partial<ImportMetaEnv> & { DEV?: boolean };

/**
 * The app's analytics: the Intake API's `enquiry_events` always; GA4 / Google Ads / the Meta
 * pixel when their ids are set (and only once consent is granted, see consent.ts); the
 * console in dev with `VITE_ANALYTICS_DEBUG=1`.
 */
export function createAppSink(api: IntakeApi, env: Env = import.meta.env): AnalyticsSink {
  const sinks: AnalyticsSink[] = [createEnquiryEventsSink({ api })];
  if (env.VITE_GA4_ID || env.VITE_GOOGLE_ADS_ID)
    sinks.push(
      createGtagSink({
        ga4Id: env.VITE_GA4_ID,
        adsId: env.VITE_GOOGLE_ADS_ID,
        adsConversions: parseConversions(env.VITE_GOOGLE_ADS_CONVERSIONS),
      }),
    );
  if (env.VITE_META_PIXEL_ID) sinks.push(createMetaPixelSink({ pixelId: env.VITE_META_PIXEL_ID }));
  if (env.DEV && env.VITE_ANALYTICS_DEBUG) sinks.push(consoleSink);
  return fanOut(...sinks);
}
